import React, { useState } from "react";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import YouTubeIcon from "@mui/icons-material/YouTube";
import logo from "../image/logo.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy"; // Copy icon
import Snackbar from "@mui/material/Snackbar"; // Snackbar for popup notification
import MuiAlert from "@mui/material/Alert"; // Alert style for Snackbar
import TermsAndConditionsModal from "./terms";
import PrivacyPolicyModal from "./privacyPolicy";

// Snackbar Alert Component
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Footer = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setSnackbarMessage(`${text} copied to clipboard!`);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const styles = `
    .footer {
      padding: 40px;
      background-color: #f0f8ff;
    }

    .footer-content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap; /* Allow items to wrap */
    }

    .footer-left,
    .footer-links,
    .footer-contact {
      flex: 1; /* Make each column take equal space */
      min-width: 250px; /* Minimum width for responsive design */
      max-width: 300px; /* Maximum width for larger screens */
      margin: 10px; /* Add margin between columns */
    }

    .footer-left p {
      margin-top: 10px;
      color: #555;
    }

    .footer-links {
      max-width: 200px;
    }

    .footer-links h4 {
      font-size: 18px;
      color: #000;
    }

    .footer-links ul {
      list-style: none;
      padding: 0;
    }

    .logo img {
      max-width: 140px; /* Set a maximum width for the logo */
      height: auto; /* Maintain aspect ratio */
      margin-right: 15px; /* Space between logo and text */
    }

    .footer-links ul li {
      margin-bottom: 10px;
    }

    .footer-links ul li a {
      text-decoration: none;
      color: #555;
    }

    .footer-contact {
      display: flex;
      flex-direction: column;
      align-items: center; /* Center content horizontally */
      justify-content: center;
      text-align: center; /* Align text to center */
      max-width: 300px;
    }

    .footer-contact h4 {
      font-size: 18px;
      margin-bottom: 15px;
    }

    .footer-contact p {
      color: #555;
    }

    .contact-info {
      display: flex;
      align-items: center;
      justify-content: center; /* Center the contact info */
      margin-bottom: 10px;
    }

    .contact-info svg {
      margin-right: 10px;
      color: grey; /* Change icon color to grey */
    }

    .contact-info a {
      text-decoration: none;
      color: #000; /* Applying HEX color */
      margin-right: 10px;
    }

    .copy-icon {
      cursor: pointer;
      color: #000; /* Applying HEX color */
    }

    .youtube-icon {
      color: #FF0000;
    }

    .footer-bottom {
      text-align: center;
      margin-top: 20px;
    }

    /* Media Query for responsiveness */
    @media (max-width: 768px) {
      .footer-content {
        flex-direction: column; /* Stack items vertically */
        align-items: center; /* Center items horizontally */
      }

      .footer-left,
      .footer-links,
      .footer-contact {
        max-width: 100%; /* Allow full width on small screens */
        text-align: center; /* Center text for better appearance */
      }

      .contact-info {
        justify-content: center; /* Center the contact info */
      }

      .copy-icon {
        margin-left: 5px; /* Add margin for better spacing */
      }

      .footer-bottom {
        text-align: center;
        margin-top: 20px;
      }

      .footer-copyright {
  text-align: center;
  font-size: 10px;
  color: #777;
  margin-top: 40px;
}

    }
  `;

  return (
    <footer className="footer" id="contactUs">
      {/* Injecting CSS into a <style> tag */}
      <style>{styles}</style>
      <div className="footer-content">
        {/* Left Section */}
        <div className="footer-left">
          <div className="logo">
            <img src={logo} alt="Appco Logo" />
          </div>
          <p>Bridging Gap between Physiotherapists and Patients</p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="#home">Home</a>
            </li>
            <li>
              <a href="#feature">Features</a>
            </li>
            <li>
              <a href="#WhyPhysiomize">Need</a>
            </li>
            <li>
              <a href="#device">Device</a>
            </li>
          </ul>
          <div className="footer-bottom">
            <TermsAndConditionsModal />
            <PrivacyPolicyModal />
          </div>
        </div>

        {/* Contact Us */}
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p>If you have any questions, feel free to contact us!</p>

          <div className="contact-info">
            <EmailIcon />
            <a href="mailto:director@physiomize.com">director@physiomize.com</a>
            <ContentCopyIcon
              className="copy-icon"
              onClick={() => handleCopy("director@physiomize.com")}
            />
          </div>
          <div className="contact-info">
            <EmailIcon />
            <a href="mailto:info@physiomize.in">info@physiomize.in</a>
            <ContentCopyIcon
              className="copy-icon"
              onClick={() => handleCopy("info@physiomize.com")}
            />
          </div>

          <div className="contact-info">
            <PhoneIcon />
            <a href="tel:+91 9348243932">+91 9348243932</a>
            <ContentCopyIcon
              className="copy-icon"
              onClick={() => handleCopy("+91 9348243932")}
            />
          </div>
        </div>
      </div>

      {/* Snackbar for copy confirmation */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div className="footer-copyright">
        © 2025 Physiomize Pvt. Ltd. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
